// extracted by mini-css-extract-plugin
export default {"selectWorkspaceDialog":"EBVxyP"};